@let localForm = registerForm();

<div class="modal-header">
  <h2 class="dark-blue-text">
    {{ auth()?.id ? ('editar_perfil' | translate) : ('$registrate' | translate) }}
  </h2>
  <span class="dismiss-modal" (click)="modalRef().dismiss()">X</span>
</div>
<div class="modal-body">
  <p class="mb-1">
    {{ 'components.register_form.complete_fields' | translate }}
  </p>
  <p class="gray-text">
    {{ 'components.register_form.required_fields' | translate }}
  </p>

  <form (ngSubmit)="registerUser()" [formGroup]="localForm" id="register-form">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div tabindex="0"></div>
          <label class="control-label">
            {{ 'components.register_form.first_name' | translate }}
          </label>
          <input type="text" class="form-control" formControlName="first_name" appFormValidation />
          <app-form-error
            [control]="localForm.get('first_name')"
            class="d-block mt-1"
          ></app-form-error>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="control-label">
            {{ 'components.register_form.last_name' | translate }}
          </label>
          <input type="text" class="form-control" formControlName="last_name" appFormValidation />
          <app-form-error
            [control]="localForm.get('last_name')"
            class="d-block mt-1"
          ></app-form-error>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label">{{ 'email' | translate }}</label>
      <input
        #email
        type="email"
        class="form-control"
        placeholder="usuario@email.com"
        formControlName="email"
        appFormValidation
        (change)="validUniqueEmail(email.value)"
      />
      <app-form-error [control]="localForm.get('email')" class="d-block mt-1"></app-form-error>
    </div>
    <div class="form-group">
      <label class="control-label">
        {{ 'components.register_form.country' | translate }}
      </label>
      <select class="form-control" formControlName="country" appFormValidation>
        <option [value]="null">{{ 'seleccione_pais' | translate }}</option>
        @for (country of countries(); track country.id) {
          <option [value]="country.id">
            {{ country.name }}
          </option>
        }
      </select>
    </div>

    @if (IS_COLOMBIA()) {
      <div class="form-group">
        <label class="control-label">
          {{ 'components.register_form.department' | translate }}
        </label>
        <select class="form-control" formControlName="state">
          <option [value]="null">
            {{ 'seleccione_departamento' | translate }}
          </option>
          @for (department of departments(); track department.id) {
            <option [value]="department.id">
              {{ department.language[0].name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label class="control-label">
          {{ 'components.register_form.municipality' | translate }}
        </label>
        <select class="form-control" formControlName="city">
          <option [value]="null">{{ 'seleccione_municipio' | translate }}</option>
          @for (municipality of municipalities(); track municipality.id) {
            <option [value]="municipality.id">
              {{ municipality.name }}
            </option>
          }
        </select>
      </div>
    }

    <div class="form-group">
      <label class="control-label">
        {{ 'components.register_form.language' | translate }}
      </label>
      <select formControlName="language" class="form-control" appFormValidation>
        <option [value]="null">{{ 'seleccione_lenguaje' | translate }}</option>
        @for (lang of languages(); track lang.id) {
          <option [value]="lang.id">
            {{ lang.name }}
          </option>
        }
      </select>
    </div>

    <div class="form-group d-flex">
      <label class="control-label">
        {{ 'components.register_form.gender' | translate }}
      </label>
      <div class="form-check form-check-inline">
        <label class="radio-group-form">
          <input
            formControlName="gender"
            id="inlineRadio1"
            [value]="2"
            type="radio"
            name="gender"
          />
          <span class="checkmark"></span>
        </label>
        <label
          [class.error-checkbox]="
            localForm.get('gender')?.touched && localForm.get('gender')?.errors?.required
          "
          class="form-check-label"
          for="inlineRadio1"
        >
          {{ 'components.register_form.female' | translate }}
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="radio-group-form">
          <input
            formControlName="gender"
            id="inlineRadio2"
            [value]="1"
            type="radio"
            name="gender"
          />
          <span class="checkmark"></span>
        </label>
        <label
          [class.error-checkbox]="
            localForm.get('gender')?.touched && localForm.get('gender')?.errors?.required
          "
          class="form-check-label"
          for="inlineRadio2"
        >
          {{ 'components.register_form.male' | translate }}
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label class="control-label">{{ '$prefix' | translate }}</label>
          <input formControlName="phone_code" type="text" class="form-control" />
        </div>
      </div>
      <div class="col-md-10">
        <div class="form-group">
          <label class="control-label">
            {{ 'components.register_form.phone' | translate }}
          </label>
          <input formControlName="phone" type="number" class="form-control" appFormValidation />
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">{{ '$form_birthdate' | translate }}</label>
      <div class="input-group flex-nowrap">
        <input
          class="form-control birthdate"
          placeholder="yyyy-mm-dd"
          name="dp"
          formControlName="birthdate"
          appFormValidation
          ngbDatepicker
          [minDate]="{ year: 1920, month: 1, day: 1 }"
          [maxDate]="{ year: 2019, month: 12, day: 31 }"
          #d="ngbDatepicker"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary rounded-start-0"
            (click)="d.toggle()"
            type="button"
          >
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">
        {{ 'components.register_form.username' | translate }}
      </label>
      <input
        #username
        type="text"
        class="form-control"
        formControlName="username"
        appFormValidation
        (change)="validUniqueUser(username.value)"
      />
    </div>

    @if (!user()) {
      <div class="form-group">
        <label class="control-label">{{ 'password' | translate }}</label>
        <div class="content-input position-relative d-flex align-items-center">
          <input
            [type]="passwordVisibility().password ? 'text' : 'password'"
            class="form-control"
            formControlName="password"
            appFormValidation
          />
          <button
            class="hidden-password dark-blue-text position-absolute end-0 me-2 p-0 bg-transparent"
            type="button"
            (click)="togglePassword('password')"
          >
            <i class="fa {{ passwordVisibility().password ? 'fa-eye-slash' : 'fa-eye' }} fs-6"></i>
          </button>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label">
          {{ 'components.register_form.confirm_password' | translate }}
        </label>
        <div class="content-input position-relative d-flex align-items-center">
          <input
            [type]="passwordVisibility().confirmPassword ? 'text' : 'password'"
            class="form-control"
            formControlName="re_password"
            appFormValidation
          />
          <button
            class="hidden-password dark-blue-text position-absolute end-0 me-2 p-0 bg-transparent"
            type="button"
            (click)="togglePassword('confirmPassword')"
          >
            <i
              class="fa {{ passwordVisibility().confirmPassword ? 'fa-eye-slash' : 'fa-eye' }} fs-6"
            ></i>
          </button>
        </div>
      </div>

      <div class="form-group">
        <div class="form-check">
          <label class="checkbox-group">
            <input [formControl]="acceptTerms()" type="checkbox" />
            <span class="checkmark"></span>
          </label>
          <label
            class="form-check-label align-top"
            [class.error-checkbox]="localForm.touched && acceptTerms()?.invalid"
          >
            {{ 'acepto_los' | translate }}
            <a class="link cursor-pointer" (click)="openTermsOrPrivacy(true)">{{
              'terminos_servicio' | translate
            }}</a>
            {{ 'y_las' | translate }}
            <a class="link cursor-pointer" (click)="openTermsOrPrivacy(false)">{{
              'politicas_privacidad' | translate
            }}</a
            >.
          </label>
        </div>
      </div>
    }

    @if (userExists()) {
      <div class="alert alert-danger" role="alert">
        {{ '$el_usuario_ya_existe' | translate }}
      </div>
    }

    <div class="text-center mb-3">
      <button type="submit" class="dark-blue fw-normal">
        {{ (user() ? '$actualizar' : '$guardar') | translate }}
      </button>
    </div>
  </form>
</div>

<app-terms-privacy-policy />
